@if (memberships()) {

  <form [formGroup]="form">
    <select [formControl]="form.controls.currentMembership"
            (change)="setCurrentMembership()"
            class="form-select form-select-sm membership-selector">

      @for (membership of memberships(); track membership.id) {
        <option [ngValue]="membership">{{ membership.host.name }}</option>
      }
    </select>
  </form>
}

